import functions from "./functions.js";

$(function () {

    const $form = $('.contact-form');
    const form = $form[0];

    if($('gmp-map').length) {
        window.loadGoogleMaps();
    }

    if (!form) {
        return;
    }
    
    $form.on('submit', e => {
        e.preventDefault();
        const $target = $(e.currentTarget);

        $('#contactModal').modal('show');

        let params = {};
        $.each($target.serializeArray(), function (i, field) {
            params[field.name] = field.value;
        });

        params['language'] = functions.getLang();
        params['recaptchaType'] = 'enterprise';
        params['giftVaucher'] = $target.attr('data-giftVaucher') ? $target.attr('data-giftVaucher') : null;

        params['mailto'] = $target.data('mailto');

        grecaptcha.enterprise.ready(function () {
            grecaptcha.enterprise.execute(functions.getRecaptchaKey(), { action: 'contact' }).then(function (token) {
                params['gRecaptchaToken'] = token;
                params = functions.getDataForUrl(params);

                $.post('/services/contact/', params).then(response => {

                    response = JSON.parse(response);
                    
                    $(".contact-response").html(response.data);
                    $('#contactModal').addClass('contact-response');
                    $('.contact-loading').addClass('d-none');

                    if (response.status == true) {
                        $('.contact-success').removeClass('d-none');
                        $target[0].reset();
                    } else {
                        $('.contact-error').removeClass('d-none');
                    }
                });
            });
        });

    });

    $('#contactModal').on('hidden.bs.modal', e => {
        $('#contactModal').removeClass('contact-response');
        $('.contact-loading').removeClass('d-none');
        $('.contact-success').addClass('d-none');
        $('.contact-error').addClass('d-none');
    });

});